import { render } from "./AppNews.vue?vue&type=template&id=da3e4dea&scoped=true"
import script from "./AppNews.vue?vue&type=script&lang=js"
export * from "./AppNews.vue?vue&type=script&lang=js"

import "./AppNews.vue?vue&type=style&index=0&id=da3e4dea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3e4dea"]])

export default __exports__